import { createContext } from 'react'

type ProficiencyGroupContextType = {
  hasImages?: boolean
}

const ProficiencyGroupContext = createContext<ProficiencyGroupContextType>({ hasImages: false })

export default ProficiencyGroupContext
